export default __webpack_public_path__ + "static/media/activate-user.a4473554.svg";